// Employee Costs Types
export const LOAD_EMPLOYEE_COST_DATA_BEGIN = 'LOAD_EMPLOYEE_COST_DATA_BEGIN'
export const LOAD_EMPLOYEE_COST_DATA_SUCCESS = 'LOAD_EMPLOYEE_COST_DATA_SUCCESS'
export const LOAD_EMPLOYEE_COST_DATA_ERROR= 'LOAD_EMPLOYEE_COST_DATA_ERROR'

export const SET_EMPLOYEE_BENEFIT_EDIT_MODE = 'SET_EMPLOYEE_BENEFIT_EDIT_MODE'
export const SET_EMPLOYEE_COST_EDIT_MODE = 'SET_EMPLOYEE_COST_EDIT_MODE'

export const UPDATE_EMPLOYEE_COSTS_BEGIN = 'UPDATE_EMPLOYEE_COSTS_BEGIN'
export const UPDATE_EMPLOYEE_COSTS_SUCCESS = 'UPDATE_EMPLOYEE_COSTS_SUCCESS'
export const UPDATE_EMPLOYEE_COSTS_ERROR = 'UPDATE_EMPLOYEE_COSTS_ERROR'

export const UPDATE_USER_BENEFIT_COST_BEGIN = 'UPDATE_USER_BENEFIT_COST_BEGIN'
export const UPDATE_USER_BENEFIT_COST_SUCCESS = 'UPDATE_USER_BENEFIT_COST_SUCCESS'
export const UPDATE_USER_BENEFIT_COST_ERROR = 'UPDATE_USER_BENEFIT_COST_ERROR'

